import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { CLINIC } from '../data/content';

const FBIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>;
const IGIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>;
const YTIcon = () => <svg width="20" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#080400"/></svg>;
const WAIcon = () => <svg width="17" height="17" viewBox="0 0 32 32" fill="currentColor"><path d="M16 0C7.163 0 0 7.163 0 16c0 2.82.737 5.467 2.027 7.76L.069 31.076l7.52-1.972A15.94 15.94 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm7.5 19.5c-.3.85-1.5 1.55-2.45 1.75-.65.14-1.5.25-4.35-.95-3.65-1.52-6-5.22-6.18-5.46-.17-.24-1.47-1.96-1.47-3.73s.93-2.64 1.26-2.97c.27-.28.72-.4 1.15-.4.14 0 .26 0 .38.01.33.01.49.03.71.55.3.69 1.03 2.47 1.12 2.65.09.18.18.42.05.66-.12.25-.22.36-.4.57-.18.2-.35.36-.53.58-.16.19-.35.4-.14.73.21.32.93 1.53 1.99 2.48 1.37 1.22 2.51 1.6 2.88 1.77.27.12.59.08.81-.14.27-.28.61-.75.95-1.22.24-.33.55-.38.87-.26.33.11 2.1.99 2.46 1.17.36.18.6.27.68.42.09.15.09.85-.21 1.67z"/></svg>;
const GoogleIcon = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M21.35 11.1H12.18V13.83H18.69C18.36 17.64 15.19 19.27 12.19 19.27C8.36 19.27 5 16.25 5 12C5 7.9 8.2 4.73 12.2 4.73C15.29 4.73 17.1 6.7 17.1 6.7L19 4.72C19 4.72 16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12C2.03 17.05 6.16 22 12.25 22C17.6 22 21.5 18.33 21.5 12.91C21.5 11.76 21.35 11.1 21.35 11.1Z"/></svg>;

const socials = [
  { url: CLINIC.facebook, icon: <FBIcon /> },
  { url: CLINIC.instagram, icon: <IGIcon /> },
  { url: CLINIC.youtube, icon: <YTIcon /> },
  { url: `https://wa.me/${CLINIC.whatsapp}`, icon: <WAIcon /> },
  { url: CLINIC.gmaps, icon: <GoogleIcon /> },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    const msg = encodeURIComponent(`Hello Vaidyam! 🌿\n\nName: ${form.name}\nPhone: ${form.phone}\nMessage: ${form.message}`);
    window.open(`https://wa.me/${CLINIC.whatsapp}?text=${msg}`, '_blank');
  };
  const inp = { width: '100%', padding: '12px 14px', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '3px', fontSize: '14px', background: '#261408', color: '#F0E6D8', outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s', boxSizing: 'border-box' };

  return (
    <div style={{ background: '#1E1108', paddingTop: '68px', minHeight: '100vh' }}>
      <Helmet>
        <title>Contact Vaidyam Ayurveda | Book Online Ayurveda Consultation</title>
        <meta name="description" content="Contact Vaidyam Kerala Ayurveda Panchakarma Treatment Center, 22 New MLA Colony, Near Unique College, Bhopal." />
      </Helmet>

      <div style={{ position: 'relative', height: '300px', overflow: 'hidden' }}>
        <img src="https://ik.imagekit.io/gnzsnmo3fr/vaidyam/hero/contacthero.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.25)' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, #1E1108, transparent 60%)' }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end', padding: '0 48px 48px' }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto', width: '100%' }}>
            <span style={{ fontSize: '10px', letterSpacing: '3px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 500, display: 'block', marginBottom: '12px' }}>Get in Touch</span>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '56px', color: '#F0E6D8' }}>Contact Us</h1>
          </div>
        </div>
      </div>

      <div style={{ padding: '60px 48px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1.3fr', gap: '64px' }}>

          {/* Left — Info */}
          <div>
            {/* Clinic Address */}
            <div style={{ marginBottom: '32px' }}>
              <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>Clinic Address</div>
              <div style={{ fontSize: '15px', color: 'rgba(240,230,216,0.65)', lineHeight: 2 }}>
                <div style={{ color: '#F0E6D8', fontWeight: 500 }}>Vaidyam Kerala Ayurveda</div>
                <div style={{ color: '#F0E6D8', fontWeight: 500, marginBottom: '4px' }}>Panchakarma Treatment Center</div>
                <div>22, New MLA Colony, Jawahar Chowk</div>
                <div>Near Unique College, Bhopal — 462003</div>
              </div>
            </div>

            <div style={{ width: '100%', height: '1px', background: 'rgba(255,255,255,0.05)', marginBottom: '28px' }} />

            {/* Phone Numbers */}
            <div style={{ marginBottom: '32px' }}>
              <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>Phone Numbers</div>
              <div style={{ fontSize: '15px', color: 'rgba(240,230,216,0.65)', lineHeight: 2.2 }}>
                <div>{CLINIC.phone1}</div>
                <div>{CLINIC.phone2}</div>
              </div>
            </div>

            <div style={{ width: '100%', height: '1px', background: 'rgba(255,255,255,0.05)', marginBottom: '28px' }} />

            {/* Clinic Timings */}
            <div style={{ marginBottom: '28px' }}>
              <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>Clinic Timings</div>
              <div style={{ fontSize: '15px', color: 'rgba(240,230,216,0.65)', lineHeight: 2.2 }}>
                <div><span style={{ color: '#F0E6D8' }}>Mon–Sat:</span> 10:00 AM – 8:30 PM</div>
                <div style={{ color: 'rgba(240,230,216,0.3)' }}>Sunday: Closed</div>
              </div>
            </div>

            <div style={{ width: '100%', height: '1px', background: 'rgba(255,255,255,0.05)', marginBottom: '28px' }} />

            {/* Doctor Timings */}
            <div style={{ marginBottom: '28px' }}>
              <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>Doctor's Timings</div>
              <div style={{ fontSize: '15px', color: 'rgba(240,230,216,0.65)', lineHeight: 2.2 }}>
                <div><span style={{ color: '#F0E6D8' }}>Morning:</span> 11:00 AM – 3:00 PM</div>
                <div><span style={{ color: '#F0E6D8' }}>Evening:</span> 6:30 PM – 8:30 PM</div>
                <div style={{ color: 'rgba(240,230,216,0.3)' }}>Sunday: Closed</div>
              </div>
            </div>
          </div>

          {/* Right — Form */}
          <div>
            <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '32px', color: '#F0E6D8', marginBottom: '8px' }}>Send a Message</h2>
            <p style={{ fontSize: '13px', color: 'rgba(240,230,216,0.35)', marginBottom: '28px' }}>We'll respond on WhatsApp within minutes.</p>
            <form onSubmit={handleSubmit}>
              {[['name', 'Your Name *', 'text', true], ['phone', 'Phone Number *', 'tel', true]].map(([name, label, type, req]) => (
                <div key={name} style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '11px', color: 'rgba(200,148,26,0.7)', fontWeight: 500, letterSpacing: '0.5px', textTransform: 'uppercase', display: 'block', marginBottom: '6px' }}>{label}</label>
                  <input required={req} type={type} name={name} value={form[name]} onChange={handle} style={inp}
                    onFocus={e => e.target.style.borderColor = 'rgba(200,148,26,0.5)'}
                    onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.08)'}
                  />
                </div>
              ))}
              <div style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '11px', color: 'rgba(200,148,26,0.7)', fontWeight: 500, letterSpacing: '0.5px', textTransform: 'uppercase', display: 'block', marginBottom: '6px' }}>Message</label>
                <textarea name="message" value={form.message} onChange={handle} rows={4} placeholder="How can Dr. Monika help you?" style={{ ...inp, resize: 'vertical' }}
                  onFocus={e => e.target.style.borderColor = 'rgba(200,148,26,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.08)'}
                />
              </div>
              <button type="submit" className="btn-gold" style={{ width: '100%', justifyContent: 'center', fontSize: '14px', padding: '14px' }}>
                Send on WhatsApp →
              </button>
            </form>

            {/* Connect with Us — below form */}
            <div style={{ marginTop: '28px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '14px' }}>Connect With Us</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                {socials.map((s, i) => (
                  <a key={i} href={s.url} target="_blank" rel="noreferrer"
                    style={{ width: '42px', height: '42px', borderRadius: '3px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(240,230,216,0.4)', transition: 'all 0.2s', textDecoration: 'none' }}
                    onMouseEnter={e => { e.currentTarget.style.color = '#C8941A'; e.currentTarget.style.borderColor = 'rgba(200,148,26,0.3)'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = 'rgba(240,230,216,0.4)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; }}
                  >{s.icon}</a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map — full width below */}
      <div style={{ padding: '48px 48px 80px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ borderRadius: '4px', overflow: 'hidden', height: '320px' }}>
            <iframe
              title="Vaidyam Ayurveda Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.784!2d77.4152!3d23.2301!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c42e4a0a0a0a0%3A0x0!2sNew+MLA+Colony%2C+TT+Nagar%2C+Bhopal!5e0!3m2!1sen!2sin!4v1"
              width="100%" height="320"
              style={{ border: 0, filter: 'invert(0.88) hue-rotate(180deg) brightness(0.85)' }}
              allowFullScreen loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
